export default __webpack_public_path__ + "static/media/debate_12.e15d1757.JPG";